import * as React from 'react';

import { Field, Fields } from 'redux-form';

import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';

import { LanguageSelectorReduxFormComponent } from '../../widgets/redux-form-fields/language-selector-redux-form-component';

import { normalizePhone } from '../../businesslogic/form-normalizers';
import { validateEmail, validatePhone, required } from '../../businesslogic/form-validators';
import { JobTitleAutocompleteReduxFormComponent } from '../job-title-autocomplete-redux-form-component';
import { RehireEligibleReduxFormComponent } from '../rehire-eligible-redux-form-component';

import { TextField, DateField } from '../../widgets/redux-form-fields/material-ui-wrappers';

interface Props {
  orgId: number;
  employee?: Employee;
  variant?: 'compact' | null;
}

export class EmployeeProfileEdit extends React.PureComponent<Props> {
  isCompact = () => this.props.variant === 'compact';

  renderName = () => (
    <Paper className="u-padding u-margin-bottom-lg">
      <div className="typo-h6">Personal Information</div>
      <FormControl className="u-width-100">
        <Field
          name="Contact.Person.firstName"
          label="First Name"
          component={TextField}
          validate={[required]}
        />
      </FormControl>
      <FormControl className="u-width-100">
        <Field
          name="Contact.Person.lastName"
          label="Last Name"
          component={TextField}
          validate={[required]}
        />
      </FormControl>
      {!this.isCompact() && (
        <FormControl className="u-width-100">
          <Field name="nickname" label="Nickname" component={TextField} />
        </FormControl>
      )}
      <FormControl className="u-width-100">
        <Field
          name="Contact.Person.phoneNumber"
          label="Cell Phone"
          component={TextField}
          normalize={normalizePhone}
          validate={[validatePhone]}
        />
      </FormControl>
      {!this.isCompact() && (
        <>
          <FormControl className="u-width-100">
            <Field
              name="Contact.Person.email"
              label="Email"
              component={TextField}
              validate={[validateEmail]}
            />
          </FormControl>
          <FormControl className="u-width-100">
            <Field name="Contact.Person.birthdate" label="Birthdate" component={DateField} />
          </FormControl>
        </>
      )}
      <FormControl className="u-width-100">
        <Field
          name="Contact.Person.languagePreference"
          label="Language Preference"
          component={LanguageSelectorReduxFormComponent}
        />
      </FormControl>
    </Paper>
  );

  renderEmploymentDetails = () => (
    <Paper className="u-padding u-margin-bottom-lg">
      <div className="typo-h6">Employment Details</div>
      {this.props.employee && !this.props.employee.isCurrentEmployee ? (
        <FormControl className="u-width-100">
          <Field
            name="rehireEligible"
            label="Rehire Eligible"
            employee={this.props.employee}
            component={RehireEligibleReduxFormComponent}
          />
        </FormControl>
      ) : null}
      {!this.isCompact() && (
        <FormControl className="u-width-100">
          <Fields
            names={['jobTitle', 'jobId']}
            label="Job Title"
            orgId={this.props.orgId}
            component={JobTitleAutocompleteReduxFormComponent}
          />
        </FormControl>
      )}
      {!this.isCompact() && (
        <FormControl className="u-width-100">
          <Field name="externalId" label="Employee Identifier" component={TextField} />
        </FormControl>
      )}
      <FormControl className="u-width-100">
        <Field name="startDate" label="Start Date" component={DateField} />
      </FormControl>
    </Paper>
  );

  render() {
    return (
      <>
        {this.renderName()}
        {this.renderEmploymentDetails()}
      </>
    );
  }
}
